<div class="component-wrapper">
    <div>
        <header class="mt-1">
            <div class="grid grid-cols-2 justify-content-between gap-1">
                <div class="d-flex justify-content-start">
                    <span class="truncate badge-phase">{{phaseDescription}}</span>
                </div>
                <div class="d-flex justify-content-end">
                    <span class="truncate " [ngClass]="isEditable || isBerichtVisible ? 'status-open' : 'status-not-editable'" >{{getEnqCardText}}</span>
                </div>
            </div>
            <button class="title-button text-xl" (click)="onTitleClick()">{{ title }}</button>
        </header>
        <section class="mt-2">
            <div class="col d-flex flex-column" style="flex-shrink: 0;">
                <kendo-label class="title" text="{{'enquiry-card.tender'|translate}}"></kendo-label>
                <span class="content">{{ausschreibung}}</span>
            </div>
            <div class="mt-2 d-flex flex-column">
                <kendo-label class="title" text="{{'enquiry-card.area'|translate}}"></kendo-label>
                <span class="content">{{bereich}}</span>
            </div>
        </section>
    </div>
    <footer class="d-flex justify-content-end">
        <!-- Öffnet die Anfrage in der normalen Detailansicht -->
        <button class="edit-button" *ngIf="isEditable" kendoButton (click)="onEditClick()" [title]="'application.edit' | translate"><i></i></button>
        <button class="view-button" *ngIf="isViewVisible" kendoButton (click)="onViewClick()" [title]="'application.view' | translate"><i></i></button>
        <!-- Öffnet die Anfrage in der Berichtsphasenansicht-->
        <button class="report-button" *ngIf="isBerichtVisible" kendoButton (click)="onBerichtClick()" [title]="'application.report' | translate">
            <i></i>
            <kendo-badge class="message-button-badge" size="large" rounded="full" *ngIf="IsAnyBerichtInBearbeitung">
                <span class="" [title]="('enquiry-card.newreport' | translate)">{{'!'}}</span>
            </kendo-badge>
        </button>
        <!-- Öffnet den Nachrichten Dialog -->
        <button class="message-button" *ngIf="isMessageVisible" kendoButton (click)="onMessageClick()" [title]="'application.message' | translate">
            <i></i>
            <kendo-badge class="message-button-badge" size="large" rounded="full" *ngIf="anfrage.anzahlUngelesenerNachrichten">
                <span class="badge-number" [title]="anfrage.anzahlUngelesenerNachrichten + ' ' + ('enquiry-card.newmessages' | translate)">{{ anfrage.anzahlUngelesenerNachrichten }}</span>
            </kendo-badge>
        </button>
        <!-- Öffnet den Antragsdatenblatt-Download Dialog -->
        <button class="download-button" *ngIf="isAntragsdatenblattAvailable" kendoButton (click)="onAntragsdatenblattClick()" [title]="'application.reportdownload' | translate"><i></i></button>
        <!-- Öffnet Mittelabruf -->
        <button class="xfound-button-secondary" *ngIf="isMittelabrufVisible" (click)="onMittelAbrufenClick()" [title]="'enquiry-card.callForFunds' | translate">
            <!-- heroicons.com - "currency-euro" outline icon -->
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="height: 1.5rem; width: 1.5rem;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14.25 7.756a4.5 4.5 0 100 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
        </button>
        <!-- Öffnet den Freigeben Dialog -->
        <button *ngIf="freigabeAktiviert" class="share-button" kendoButton (click)="onShareClick()" [title]="'application.share' | translate"><i></i></button>
        <!-- Öffnet den Anfrage-Zurückziehen Dialog -->
        <button class="revoke-button" *ngIf="isRevokable" kendoButton (click)="onRevokeClick()" [title]="'application.revoke' | translate"><i></i></button>
        <!-- Öffnet den Anfrage-Löschen Dialog -->
        <button class="delete-button" *ngIf="isDraft" kendoButton (click)="onDeleteClick()" [title]="'application.delete' | translate"><i></i></button>
    </footer>
</div>